
export default {
  getMyBaseInfo: { // 나의 정보 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/getMyBaseInfo'
  },
  getModifyMyInfo: { // 나의 정보 수정 (조회)
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/getModifyMyInfo'
  },
  modifyMyInfo: { // 나의 정보 수정
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/modifyMyInfo'
  },
  modifyMemberPswd: { // 비밀번호 변경
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/modifyMemberPswd'
  },
  checkMbrPswd: { // 비밀번호 확인
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/checkMbrPswd'
  },
  getMbrWithdrawal: { // 탈퇴 회원에 대한 정보들 조회
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/getMbrWithdrawal'
  },
  procMbrWithdrawal: { // 회원 탈퇴 처리
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/myInfo/procMbrWithdrawal'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/myInfoApi.js